// @flow

import * as React from "react"
import { Spin } from "antd"
import styles from "./WideSpinner.scss"

class WideSpinner extends React.Component<{}> {
  render(): React$Element<"div"> {
    return (
      <div className={styles.container}>
        <Spin />
      </div>
    )
  }
}

export default WideSpinner
